// File: src/pages/auth/ChangePasswordPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ChangePasswordPage() {
    const [formData, setFormData] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
    const [message, setMessage] = useState({ type: '', text: '' });
    const [isLoading, setIsLoading] = useState(false);
    
    // State cho con mắt (ẩn/hiện mật khẩu)
    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    // Hàm xử lý khi bấm nút Quay lại (Xóa data để tránh Chrome hỏi lưu pass)
    const handleBack = () => {
        setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
        navigate(-1);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });

        if (formData.newPassword !== formData.confirmPassword) {
            return setMessage({ type: 'error', text: 'Mật khẩu mới không khớp!' });
        }
        if (formData.newPassword.length < 6) {
            return setMessage({ type: 'error', text: 'Mật khẩu phải có ít nhất 6 ký tự.' });
        }

        setIsLoading(true);
        try {
            const token = localStorage.getItem('skillmatch_token');
            const res = await fetch(`${API_URL}/api/auth/change-password`, {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'x-auth-token': token
                },
                body: JSON.stringify({ 
                    oldPassword: formData.oldPassword, 
                    newPassword: formData.newPassword 
                })
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.message);

            setMessage({ type: 'success', text: 'Cập nhật mật khẩu thành công!' });
            setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
            setTimeout(() => navigate(-1), 2000); 
        } catch (error) {
            setMessage({ type: 'error', text: error.message });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        // Đã sửa class: Thêm pt-24 để cách xa Navbar, dùng items-center để căn giữa
        <div className="min-h-screen bg-gray-50 flex justify-center items-center pt-24 pb-12 px-4">
            <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
                <button type="button" onClick={handleBack} className="text-sm font-semibold text-gray-500 hover:text-blue-600 mb-6 flex items-center gap-1">
                    <span className="material-symbols-outlined text-base">arrow_back</span> Quay lại
                </button>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Đổi mật khẩu</h2>

                {message.text && (
                    <div className={`p-4 mb-6 rounded-lg text-sm font-medium ${message.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                        {message.text}
                    </div>
                )}

                {/* Thêm autoComplete="off" vào form */}
                <form onSubmit={handleSubmit} className="space-y-5" autoComplete="off">
                    
                    {/* Mật khẩu cũ */}
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">
                            Mật khẩu hiện tại <span className="text-gray-400 font-normal text-xs ml-1">(Bỏ qua nếu đăng nhập Google)</span>
                        </label>
                        <div className="relative">
                            <input 
                                type={showOld ? "text" : "password"} 
                                name="oldPassword" 
                                value={formData.oldPassword} 
                                onChange={handleChange} 
                                autoComplete="new-password" // Chống Chrome auto-fill
                                className="w-full p-3 pr-10 bg-gray-50 border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-blue-500" 
                            />
                            <span 
                                className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer select-none"
                                onClick={() => setShowOld(!showOld)}
                            >
                                {showOld ? 'visibility_off' : 'visibility'}
                            </span>
                        </div>
                    </div>

                    {/* Mật khẩu mới */}
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Mật khẩu mới</label>
                        <div className="relative">
                            <input 
                                type={showNew ? "text" : "password"} 
                                name="newPassword" 
                                value={formData.newPassword} 
                                onChange={handleChange} 
                                required 
                                autoComplete="new-password"
                                className="w-full p-3 pr-10 bg-gray-50 border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-blue-500" 
                            />
                            <span 
                                className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer select-none"
                                onClick={() => setShowNew(!showNew)}
                            >
                                {showNew ? 'visibility_off' : 'visibility'}
                            </span>
                        </div>
                    </div>

                    {/* Xác nhận mật khẩu mới */}
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Xác nhận mật khẩu mới</label>
                        <div className="relative">
                            <input 
                                type={showConfirm ? "text" : "password"} 
                                name="confirmPassword" 
                                value={formData.confirmPassword} 
                                onChange={handleChange} 
                                required 
                                autoComplete="new-password"
                                className="w-full p-3 pr-10 bg-gray-50 border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-blue-500" 
                            />
                            <span 
                                className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer select-none"
                                onClick={() => setShowConfirm(!showConfirm)}
                            >
                                {showConfirm ? 'visibility_off' : 'visibility'}
                            </span>
                        </div>
                    </div>

                    <button type="submit" disabled={isLoading} className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-colors">
                        {isLoading ? 'Đang cập nhật...' : 'Cập nhật mật khẩu'}
                    </button>
                </form>
            </div>
        </div>
    );
}